import { render, staticRenderFns } from "./oidc-callback-error.vue?vue&type=template&id=c83d3ccc&scoped=true&"
import script from "./oidc-callback-error.vue?vue&type=script&lang=js&"
export * from "./oidc-callback-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83d3ccc",
  null
  
)

export default component.exports